import { cn } from "@/lib/cn.js";
import type { Tono } from "@/lib/webchat/estado.js";

const COLOR_PUNTO: Record<Tono, string> = {
  ok: "bg-emerald-500",
  aviso: "bg-amber-500",
  error: "bg-rose-500",
  info: "bg-sky-500",
  neutro: "bg-slate-400",
};

/**
 * Estado con un punto de color y su etiqueta en texto: el color nunca es la
 * única señal (se lee igual sin distinguir colores).
 */
export function StatusDot({ tono, etiqueta, className }: Readonly<{ tono: Tono; etiqueta: string; className?: string }>) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-sm whitespace-nowrap", className)}>
      <span aria-hidden="true" className={cn("inline-block w-2 h-2 rounded-full shrink-0", COLOR_PUNTO[tono])} />
      <span>{etiqueta}</span>
    </span>
  );
}
